import { insert as publicInsert, update as publicUpdate, save as publicSave, get as publicGet, remove as publicRemove, truncate as publicTruncate, bulkInsert as publicBulkInsert, bulkUpdate as publicBulkUpdate, bulkSave as publicBulkSave, bulkRemove as publicBulkRemove, isReferenced as publicIsReferenced, insertReference as publicInsertReference, removeReference as publicRemoveReference, replaceReferences as publicReplaceReferences, query as publicQuery, search as publicSearch, patch as publicPatch, bulkPatch as publicBulkPatch, aggregate as publicAggregate, aggregatePipeline as publicAggregatePipeline, queryReferenced as publicQueryReferenced, filter as publicFilter, withEnvironment as publicWithEnvironment, onDataItemCreated as publicOnDataItemCreated, onDataItemUpdated as publicOnDataItemUpdated, onDataItemDeleted as publicOnDataItemDeleted, } from './data-v2-data-item-items.public';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
export const insert = /*#__PURE__*/ createRESTModule(publicInsert);
export const update = /*#__PURE__*/ createRESTModule(publicUpdate);
export const save = /*#__PURE__*/ createRESTModule(publicSave);
export const get = /*#__PURE__*/ createRESTModule(publicGet);
export const remove = /*#__PURE__*/ createRESTModule(publicRemove);
export const truncate = /*#__PURE__*/ createRESTModule(publicTruncate);
export const bulkInsert = /*#__PURE__*/ createRESTModule(publicBulkInsert);
export const bulkUpdate = /*#__PURE__*/ createRESTModule(publicBulkUpdate);
export const bulkSave = /*#__PURE__*/ createRESTModule(publicBulkSave);
export const bulkRemove = /*#__PURE__*/ createRESTModule(publicBulkRemove);
export const isReferenced = /*#__PURE__*/ createRESTModule(publicIsReferenced);
export const insertReference = /*#__PURE__*/ createRESTModule(publicInsertReference);
export const removeReference = /*#__PURE__*/ createRESTModule(publicRemoveReference);
export const replaceReferences = /*#__PURE__*/ createRESTModule(publicReplaceReferences);
export const query = /*#__PURE__*/ createRESTModule(publicQuery);
export const search = /*#__PURE__*/ createRESTModule(publicSearch);
export const patch = /*#__PURE__*/ createRESTModule(publicPatch);
export const bulkPatch = /*#__PURE__*/ createRESTModule(publicBulkPatch);
export const aggregate = /*#__PURE__*/ createRESTModule(publicAggregate);
export const aggregatePipeline = /*#__PURE__*/ createRESTModule(publicAggregatePipeline);
export const queryReferenced = /*#__PURE__*/ createRESTModule(publicQueryReferenced);
export const filter = /*#__PURE__*/ createRESTModule(publicFilter);
export const withEnvironment = /*#__PURE__*/ createRESTModule(publicWithEnvironment);
/**
 * Triggered when a data item is inserted.
 */
export const onDataItemCreated = createEventModule(publicOnDataItemCreated);
/**
 * Triggered when a data item is updated or patched.
 */
export const onDataItemUpdated = createEventModule(publicOnDataItemUpdated);
/**
 * Triggered when a data item is deleted or truncated.
 */
export const onDataItemDeleted = createEventModule(publicOnDataItemDeleted);
export { Environment, stages, } from './data-v2-data-item-items.universal';
export * from './data-v2-data-item-items.types';
//# sourceMappingURL=data-v2-data-item-items.context.js.map